export default __webpack_public_path__ + "static/media/b252d464-65cb-4950-88f7-ac0a1bf79b75.57afe4fd.woff";